var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPicture8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-505 -401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M535.95 432.2C539.85 428.45 540.05 422.25 536.35 418.25 540.3 420.3 543.55 423.45 545.45 425.55 543.45 427.5 540.05 430.4 535.95 432.2ZM516.3 421.9C517.95 420.5 519.7 419.3 521.6 418.3 517.95 422.3 518.15 428.45 522.05 432.2 517.95 430.4 514.5 427.5 512.55 425.55 513.7 424.25 514.95 423.05 516.3 421.9L516.3 421.9ZM529 433C524.6 433 521 429.4 521 425 521 420.6 524.6 417 529 417 533.4 417 537 420.6 537 425 537 429.4 533.4 433 529 433ZM548.45 424.15C545.55 420.75 537.95 413 529 413 520.05 413 512.45 420.75 509.55 424.15 508.8 425.05 508.85 426.3 509.65 427.15 512.6 430.25 520.15 437 529 437 537.85 437 545.4 430.25 548.4 427.15 549.15 426.35 549.2 425.05 548.45 424.15Z",
    fill: "#C18D34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534 425C534 427.761 531.761 430 529 430 526.239 430 524 427.761 524 425 524 422.239 526.239 420 529 420 531.761 420 534 422.239 534 425Z",
    fill: "#C18D34"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture8);
export default __webpack_public_path__ + "static/media/Picture8.ed1750f09c061a8f583aca40d16605e7.svg";
export { ForwardRef as ReactComponent };